import React, { useState } from "react";
import WechatQRCode from "../../assets/bitcoin-garaace.png";
import { SUPPORT_TOOLTIP_TITLE } from "../../constants/Constants";
import { Tooltip, useMediaQuery } from "@mui/material";
import IconButton from "../utils/IconButton";
import { FaBitcoin } from "react-icons/fa6";

const SupportMe = () => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const isTouchDevice = useMediaQuery('(pointer: coarse)');

  const bitcoinAddress = "1MfnBDgUTiKksc1VXtdcojMjET82Fvpzy7";

  const copyToClipboard = () => {
    navigator.clipboard.writeText(bitcoinAddress).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleClick = () => {
    if (isTouchDevice) {
      setOpen(prev => !prev);
    }
  };

  const handleTooltipOpen = () => {
    if (!isTouchDevice) {
      setOpen(true);
    }
  };

  const handleTooltipClose = () => {
    if (!isTouchDevice) {
      setOpen(false);
    }
  };

  return (
    <Tooltip
      title={
        <div style={{ maxWidth: 350, padding: "25px" }}>
          <span style={{ whiteSpace: "pre-line", fontSize: "12px" }}>
            {SUPPORT_TOOLTIP_TITLE}
          </span>
          <img
            className="support-me-image"
            src={WechatQRCode}
            alt="Wechat QR Code"
            style={{ marginTop: "15px", width: "100%" }}
          />
          <div style={{ marginTop: "15px", fontSize: "12px" }}>
            <strong>Bitcoin Address:</strong>
            <div
              style={{
                wordBreak: "break-word",
                fontFamily: "monospace",
                margin: "3px 0",
              }}
            >
              {bitcoinAddress}
            </div>
            <button
              onClick={copyToClipboard}
              style={{
                width: "100%",
                padding: "10px 15px",
                fontSize: "15px",
                cursor: "pointer",
                borderRadius: "30px",
                backgroundColor: "#ff5722",
                border: "0px solid #ccc",
                margin: "15px 0",
              }}
            >
              {copied ? "✓ Waad copy-yaysay" : "Copy-yee"}
            </button>
          </div>
        </div>
      }
      placement="top-start"
      open={open}
      onOpen={handleTooltipOpen}
      onClose={handleTooltipClose}
      componentsProps={{
        tooltip: {
          sx: {
            borderRadius: "30px",
          },
        },
      }}
    >
      <IconButton color="inherit" onClick={handleClick}>
        <FaBitcoin className="support-me" fontSize="28px" />
      </IconButton>
    </Tooltip>
  );
};

export default SupportMe;
